import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "about" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "仅管理员可见")
], -1)
const _hoisted_2 = { style: { marginTop: '20px' } }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, " You can customize modal body text by the current situation. This modal will be closed immediately once you press the OK button. ", -1)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {

const visible = ref(false);
const position = ref("left");

const handleClick = () => {
  visible.value = true;
};
const handleOk = () => {
  visible.value = false;
};
const handleCancel = () => {
  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_button, {
        type: "text",
        status: "normal",
        size: "mini",
        onClick: handleClick
      }, {
        default: _withCtx(() => [
          _createTextVNode("回复详情 ")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_drawer, {
      width: 340,
      height: 340,
      visible: visible.value,
      placement: position.value,
      onOk: handleOk,
      onCancel: handleCancel,
      unmountOnClose: ""
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Title")
      ]),
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["visible", "placement"])
  ], 64))
}
}

})